// extracted by mini-css-extract-plugin
module.exports = {"rating":"Pg","numberOfStars":"Qg","count":"Rg"};